import React from "react";
import { ForumsTopicPostsContainer } from "../../../containers/forums/ForumsTopicPostsContainer";
import { useForumsNavigation } from "../../../hooks/useForumNavigation";
import { BANNER_FORUM_GUEST_PAGE } from "../../../utilities/assets/assetHelper";
import { EForumTopic } from "../../../utilities/forums";
import { useTranslation } from "react-i18next";

export const ForumsGuestPage = () => {
    const { t } = useTranslation();
    const { navigateToNewPost, navigateToArticle, navigateToPost } = useForumsNavigation();

    const handleCreateNewPost = () => {
        navigateToNewPost(EForumTopic.GUEST)
    }

    return <ForumsTopicPostsContainer
        topic={EForumTopic.GUEST}
        banner={{
            title: t('forum.guest.title'),
            backgroundImageSrc: BANNER_FORUM_GUEST_PAGE,
            subTitle: t('forum.guest.subTitle'),
            primaryButton: { text: t('forum.topic.newPostButton'), onClick: handleCreateNewPost }
        }}
        onCreateNewPostClick={handleCreateNewPost}
        navigateToPost={navigateToPost}
        navigateToArticle={navigateToArticle} />;
}